import React, { useState } from "react";
import { BlackAndWhite } from "../../../../../themes/Colors";

const SubCategoryCard = ({
  title,
  description,
  hasSubCategory,
  imageIcon,
  imageIcon2,
  onClick,
  width,
}) => {
  const [hover, setHover] = useState(false);
  return (
    <div
      onClick={onClick}
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      style={{
        margin: 15,
        borderRadius: 8,
        display: "flex",

        transition: "all 0.1s",
        cursor: "pointer",
        flexDirection: "column",
        backgroundColor: BlackAndWhite.secondary,
        overflow: "hidden",
        borderStyle: hover ? "solid" : "none",
        borderWidth: hover ? 5 : 0,
        borderColor: "#FAA919",
        WebkitBoxShadow: "0px 0px 10px 1px #00000066",
      }}
    >
      <div
        style={{
          height: 200,
          width: width ? width : 200,
          overflow: "hidden",
          position: "relative",
        }}
      >
        <div
          style={{
            width: "100%",
            fontSize: 22,
            textAlign: "center",
            height: 60,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontWeight: "bold",
            position: "absolute",
            color: BlackAndWhite.secondary,
          }}
        >
          {title}
        </div>

        <img
          alt="Logo"
          src={require("../../../../../images/marijuana-buds-with-marijuana-joints-cannabis-oil.jpg")}
          style={{
            height: "100%",
          }}
        />
      </div>
      <div
        style={{
          height: 125,
          width: 200,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          color: hover ? BlackAndWhite.primary : BlackAndWhite.primary,
          alignItems: "center",
          justifyContent: "center",
          WebkitBoxShadow: "0px 0px 10px 1px #00000066",
        }}
      >
        <div
          style={{
            marginTop: 10,
            fontWeight: "bold",
            marginBottom: 6,
            width: "90%",
            textAlign: "left",
          }}
        >
          Description:
        </div>
        <div
          style={{
            width: "90%",
            textAlign: "left",
            marginBottom: 5,
          }}
        >
          {description}
        </div>
        <div>{hasSubCategory}</div>
      </div>
    </div>
  );
};

export default SubCategoryCard;
